import { useState } from 'react';

export const useSelection = () => {
  const [selectedIds, setSelectedIds] = useState([]);

  const handleCheckboxClick = (e, id) => {
    setSelectedIds((prev) => {
      if (!Array.isArray(prev)) {
        prev = [];
      }
      return e.target.checked ? [...prev, id] : prev.filter((item) => item !== id);
    });
  };

  const handleSelectAll = (items) => (e) => {
    if (e.target.checked) {
      const allIds = items.map((item) => item.id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  return {
    selectedIds,
    setSelectedIds,
    handleCheckboxClick,
    handleSelectAll
  };
}; 